import React, { useRef, useState, type RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';

import {
  NavigationScroll,
  useDialogHelpers,
} from '@uncinc/uncinc-react-kitchen-sink';
import { RecursiveMenuTransitions } from '@uncinc/react-drupal-core';

import Header from './Header';

import './style.scss';

const HeaderMenu: React.FC<{ searchInputRef: RefObject<HTMLInputElement> }> = ({ searchInputRef }) => {
  const menu = useRef<HTMLDivElement>(null);
  const header = useRef<HTMLDivElement>(null);
  const lottie = useRef(null);
  const { t } = useTranslation();
  // hier iets doen met menu sluiten als je op het logo klikt

  // We need to both use a ref and state here.
  // Without the ref, the lottie will not animate properly, because
  // of rerendering within the menu button. We need the state because
  // otherwise the useDialogHelpers hook won't redefine the isOpen boolean.
  const isOverlayOpen = useRef<boolean>(false);
  const [isDialogOpen, setDialogOpen] = useState(false);

  // TODO: refactor this to use either ref or state (or fix lottie component)
  const toggleOverlay = (onlyClose = false) => {
    if ((!onlyClose || isOverlayOpen.current) && lottie.current) {
      // @ts-ignore
      lottie.current.play();
    }

    if (onlyClose) {
      isOverlayOpen.current = false;
    } else {
      isOverlayOpen.current = !isOverlayOpen.current;
    }

    setDialogOpen(isOverlayOpen.current);

    if (header.current) {
      header.current.className = isOverlayOpen.current
        ? 'HeaderMenu__Header__menu hide'
        : 'HeaderMenu__Header__menu show';
    }

    if (menu.current) {
      menu.current.className = `HeaderMenu ${isOverlayOpen.current ? 'overlay-menu-open' : ''}`;
    }
  };

  const HeaderMenuClassnames = c(
    'HeaderMenu',
    { 'overlay-menu-open': isOverlayOpen.current },
  );

  const { dialogHelpersProps } = useDialogHelpers<HTMLDivElement>({
    wrapperElement: menu,
    isOpen: isDialogOpen,
    closeFunction: toggleOverlay,
    disableClosers: false,
    ariaLabel: String(t('general.header_menu')),
  });

  return (
    <NavigationScroll>
      <div
        ref={menu}
        className={HeaderMenuClassnames}
        {...dialogHelpersProps}
      >
        <RecursiveMenuTransitions.MenuTransitionProvider>
          <Header
            key="header"
            isOverlayOpen={isOverlayOpen}
            toggleOverlay={toggleOverlay}
            headerRef={header}
            lottieRef={lottie}
            searchInputRef={searchInputRef}
          />
        </RecursiveMenuTransitions.MenuTransitionProvider>
      </div>
    </NavigationScroll>
  );
};

export default HeaderMenu;
